import React, { FC } from "react"
import { Icon, Input, StrictInputProps } from "@metsooutotec/modes-react-components"
import { observer } from "mobx-react-lite"
import asEditorStore from "./local-store/asset-section-editor-store"

export interface AssetSectionSettings {
    sensorNotificationArea: number
    radiusHint: number
    lineWeight: number
}

const AssetSectionEditorsettings: FC = observer(() => {
    const { assetSectionSettings, setAssetSectionSettings } = asEditorStore
    const handleChange = (id: string, value: string) => {
        const updatedSettings = { ...assetSectionSettings, [id]: Number(value) }
        setAssetSectionSettings(updatedSettings)
    }
    const onClearClick = (inputId: string) => {
        const updatedSettings = { ...assetSectionSettings, [inputId]: 0 }
        setAssetSectionSettings(updatedSettings)
    }
    const clearIcon = (id: string) => {
        return (assetSectionSettings as any)[id] !== 0 ? <Icon className='icon-cross-circle-fill-16' onClick={() => onClearClick(id)} /> : null
    }

    const inputConfig: Array<StrictInputProps & { value: number }> = [
        {
            id: "sensorNotificationArea",
            label: "Sensor Notification Area",
            placeholder: "Enter sensor notification area",
            type: "number",
            required: false,
            uiRequired: false,
            value: assetSectionSettings.sensorNotificationArea,
            heightClass: "small",
            spanning: true,
            icon: clearIcon("sensorNotificationArea"),
        },
        {
            id: "radiusHint",
            label: "Radius Hint",
            placeholder: "Enter radius hint",
            type: "number",
            required: false,
            uiRequired: false,
            value: assetSectionSettings.radiusHint,
            heightClass: "small",
            spanning: true,
            icon: clearIcon("radiusHint"),
        },
        {
            id: "lineWeight",
            label: "Line Weight",
            placeholder: "Enter line weight",
            type: "number",
            required: false,
            uiRequired: false,
            value: assetSectionSettings.lineWeight,
            heightClass: "small",
            spanning: true,
            icon: clearIcon("radiusHint"),
        },
    ]

    return (
        <>
            <p style={{ fontSize: "1.5vw", marginBottom: "0.25em" }}>
                <strong>SVG Settings</strong>
            </p>
            {inputConfig.map(config => (
                <Input
                    key={config.id}
                    style={{ marginBottom: "var(--size-xs)" }}
                    {...config}
                    onChange={e => handleChange(config.id as string, e.target.value)}
                />
            ))}
        </>
    )
})

export default AssetSectionEditorsettings
